import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import homePage from '@/pages/home/homePage'
import RecruitmentOrder from '@/pages/home/RecruitmentOrder'
import RecruitmentDetails from '@/pages/home/RecruitmentDetails'
import MyOrder from '@/pages/home/MyOrder'
import MyOrderDetails from '@/pages/home/MyOrderDetails'
import PersonalCenter from '@/pages/home/PersonalCenter'
import AgentCenter from '@/pages/home/AgentCenter'
import AboutUs from '@/pages/home/AboutUs'
import login from '@/pages/login/login'
import register from '@/pages/login/register'
import SettlementDetails from '@/pages/details/SettlementDetails'
import AgentDetails from '@/pages/details/AgentDetails'
import article from '@/pages/home/article'
import pdf from '@/pages/home/pdf'
import Withdrawal from "@/pages/home/Withdrawal"
Vue.use(Router)

const isProduction = process.env.NODE_ENV === 'production'

export default new Router({
  mode: 'history',
  base: '/',
  // base: isProduction ? '/StateGridFiveColorForDJFZ' : '/',
  routes: [
    {
      path: '',
      redirect: '/homePage'
    },
    {
      path: '/home', 
      component: home,
      name: 'Home',
     meta: { requiresAuth: true },
      children: [  //路由的嵌套，实现页面局部刷新
        {
          path: '/homePage',
          name: 'index',
          component: homePage,
        },
        {
          path: '/RecruitmentOrder',
          name: 'RecruitmentOrder',
          component: RecruitmentOrder,
        },
        {
          path: '/RecruitmentDetails',
          name: 'RecruitmentDetails',
          component: RecruitmentDetails,
        },
        {
          path: '/MyOrder',
          name: 'MyOrder',
          component: MyOrder,
        },
         {
          path: '/AgentCenter',
          name: 'AgentCenter',
          component: AgentCenter,
        },
        
        {
          path: '/MyOrderDetails',
          name: 'MyOrderDetails',
          component: MyOrderDetails,
        },
        {
          path: '/PersonalCenter',
          name: 'PersonalCenter',
          component: PersonalCenter,
        },
        {
          path: '/AboutUs',
          name: 'AboutUs',
          component: AboutUs,
        },
        
         {
          path: '/AgentDetails',
          name: 'AgentDetails',
          component: AgentDetails,
        },
        {
          path: '/SettlementDetails',
          name: 'SettlementDetails',
          component: SettlementDetails,
        },{
          
          path: '/article',
          name: 'article',
          component:article,
        },{
          
          path: '/pdf',
          name: 'pdf',
          component:pdf,
        },
        {
          path:'/Withdrawal',
          name:'Withdrawal',
          component:Withdrawal,
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/register',
      name: 'register',
      component: register,
    },
    // {
    //   path: '/login', 
    //   component: login,
    //   name: 'login',
    //   meta: { },
    //   children: [  //路由的嵌套，实现页面局部刷新
    //     {
    //       path: '/login',
    //       name: 'login',
    //       component: login,
    //     },
    //     {
    //       path: '/register',
    //       name: 'register',
    //       component: register,
    //     },
    //   ]
    // },
    {
      path: '*',
      redirect: '/home',
    },
    // {
    //   path: '/homePage',
    //   name: 'homePage',
    //   component: homePage,
    // },
  //   {
  //     path:'/',  //页面最初加载的路径，默认为/
  //     name:'home',
  //     component:home,  //页面最初加载的组件
  //     redirect:'/home',  //路由重定位，由于刚开始的路由'/'没有对应的组件显示，所以设置页面加载时显示'/index'首页内容
  //     children: [  //路由的嵌套，实现页面局部刷新
  //       {
  //         path: '/homePage',
  //         name: 'homePage',
  //         component: homePage,
  //       },
  //     ]
  // }
  ]
})


// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
